import React from 'react';

import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';

import { container } from '../../styles';
import { DetailsLayoutContainerProps } from './types';

const DetailsLayoutContainer: React.FC<React.PropsWithChildren<DetailsLayoutContainerProps>> = (
  props,
) => {
  const { className, children } = props;

  return (
    <Stack className={cn(container, className)} direction="col" justifyContent="center">
      {children}
    </Stack>
  );
};

export default DetailsLayoutContainer;
